import { memo, useState, useEffect } from "react";
import HoverTippable from "../HoverTippable";
import { useStoryBibleStore } from "../../../stores/storyBibleStore";
import { useProjectStore } from "../../../stores/projectStore";
import GoButton from "../../GoButton";
import StickyNoteAnchor from "../../StickyTour/StickyNoteAnchor";
import { AnchorIds } from "../../StickyTour/TourTypes";

const GenerateProseGoButton = ({ selectOnly = false, generateProse, editor, setScenes, sceneId, generateDisabled, proseMode, proseModes, setLastInvocation, outOfQuotaOverride }) => {
  const requesting = useStoryBibleStore((state) => state.requesting);
  const storeOutOfQuota = useStoryBibleStore((state) => state.outOfQuota);
  const outOfQuota = outOfQuotaOverride ?? storeOutOfQuota;

  const resetScrollCount = useProjectStore((state) => state.resetScrollCount);
  const setUserScrolled = useProjectStore((state) => state.setUserScrolled);
  const [requested, setRequested] = useState(false);

  const generateDisabledMessage = "Please fix your errors before generating.";

  const generateLabel = "Generate";

  useEffect(() => {
    const handleKeyPress = (e) => {
      // Check for cmd/ctrl + enter
      if ((e.metaKey || e.ctrlKey) && e.key === "Enter") {
        // Only trigger if button is not disabled
        if (!requesting && !outOfQuota && !generateDisabled) {
          generateProse();
        }
      }
    };

    document.addEventListener("keydown", handleKeyPress);
    return () => document.removeEventListener("keydown", handleKeyPress);
  }, [requesting, outOfQuota, generateDisabled, resetScrollCount, setUserScrolled, editor, generateProse, setRequested, setLastInvocation]);

  return (
    <HoverTippable
      generateDisabled={generateDisabled && !selectOnly} // selectOnly version should always be selectable
      generateDisabledMessage={generateDisabledMessage}
      submenuActive={true}
      id={`button-container-generate-prose-go`}
      outOfQuotaOverride={outOfQuota}
    >
      <StickyNoteAnchor anchorId={AnchorIds.DRAFT_PROSE_GENERATE_GO} />
      <GoButton
        id="button-generate-prose"
        disabled={requesting || outOfQuota || generateDisabled}
        onClick={generateProse}
        selectOnly={selectOnly}
        useModelSelectionModal={true}
        proseMode={proseMode}
        proseModes={proseModes}
        labelOverride="Generate Draft"
      />
    </HoverTippable>
  );
};

export default memo(GenerateProseGoButton);
